import { LayoutDataType } from '../../types';

export const OPTIONS: {
  id: LayoutDataType['gender'];
  title: string;
}[] = [
  {
    id: 'women',
    title: 'WOMAN',
  },
  {
    id: 'man',
    title: 'MAN',
  },
  {
    id: 'non-binary',
    title: 'NON-BINARY PERSON',
  },
];
